import { useState } from "react";
import PrimaryButton from "../Button/PrimaryButton";
import AuthFormLayout from "./AuthFormLayout";
import AuthField from "./AuthField";
import api from "../../utils/axiosInstance";

// Step two of login. The challenge token from /auth/login stands in for the
// session until a valid code is supplied.
const MfaChallengeForm = ({ mfaToken, onVerified, onRestart }) => {
  const [code, setCode] = useState("");
  const [useRecovery, setUseRecovery] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const value = code.trim();
    if (!value) {
      setError(useRecovery ? "Enter a recovery code." : "Enter your 6-digit code.");
      return;
    }

    setSubmitting(true);
    try {
      const payload = useRecovery
        ? { mfaToken, recoveryCode: value }
        : { mfaToken, code: value };

      const res = await api.post("/auth/mfa/verify", payload, {
        withCredentials: true,
      });
      await onVerified(res.data);
    } catch (err) {
      const data = err.response?.data;
      if (data?.restart) {
        onRestart(data.error);
        return;
      }
      setError(data?.error || "Verification failed. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <AuthFormLayout
      title="Two-Factor Verification"
      subtitle={
        useRecovery
          ? "Enter one of the recovery codes you saved when you turned on two-factor authentication."
          : "Enter the 6-digit code from your authenticator app."
      }
      error={error}
      onSubmit={handleSubmit}
      footer={
        <button
          type="button"
          onClick={() => {
            setUseRecovery((current) => !current);
            setCode("");
            setError("");
          }}
          className="w-full text-center text-xs font-semibold text-brand-600 hover:underline"
        >
          {useRecovery ? "Use my authenticator app instead" : "Use a recovery code"}
        </button>
      }
    >
      <AuthField
        name={useRecovery ? "recoveryCode" : "code"}
        label={useRecovery ? "Recovery Code" : "Verification Code"}
        placeholder={useRecovery ? "XXXXX-XXXXX" : "123456"}
        autoComplete="one-time-code"
        value={code}
        onChange={(e) => {
          setCode(e.target.value);
          setError("");
        }}
      />

      <PrimaryButton type="submit" disabled={submitting}>
        {submitting ? "Verifying..." : "Verify"}
      </PrimaryButton>
    </AuthFormLayout>
  );
};

export default MfaChallengeForm;
